import { sendToGtm } from '@s1/core/event-tracking';

const sendArticleCostToGA = () => {
  window.s1.wpDataStack = window.s1.wpDataStack || {};

  if (typeof window.s1.wpDataStack.pageInfo.article_cost !== 'undefined') {
    const trackingObject = {
      event: 'Unified Event',
      eventCategory: 'Article Cost',
      eventAction: 'Get Article Cost',
      eventLabel: 'Article Cost',
      eventValue: window.s1.wpDataStack.pageInfo.article_cost,
    };

    sendToGtm(trackingObject);
    console.log('ArticleCost Sent to dataLayer', trackingObject);
  }
};

export default sendArticleCostToGA;
